<template>
  <div class="group-link-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-collection-tag"></i> Monthly fee group link</span>
        <el-button icon="el-icon-plus" style="float: right; padding: 0" type="text"
          @click="showDialog()">Create Group</el-button>
      </div>
      
      <el-table
        v-loading="loading"
        ref="tableemberMonthlyfeeGroup"
        :data="groupList"
        style="width: 100%"
        row-key="id"
        border
        lazy
        :load="loadMembers"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
      
      <el-table-column label="Group / Member Name" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'group'" style="font-weight: bold;">
            <i class="el-icon-folder-opened"></i> {{ scope.row.name }}
          </span>
          <span v-else>
             ({{ scope.row.memberCode }})
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="memberCode" label="Code" width="180"></el-table-column>
      <el-table-column prop="projectName" label="Project Name"></el-table-column>
      <el-table-column prop="customerName" label="Customer Name"></el-table-column>
      <!-- <el-table-column prop="enduserId" label="EndUser ID" show-overflow-tooltip></el-table-column> -->
      <el-table-column label="Dept" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'group'" style="font-weight: bold;">
             {{ scope.row.hasDebt ? 'Has Dept' : 'No Dept' }}
          </span>
          <span v-else>
             {{ scope.row.totalDebt }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Action" width="150">
        <template slot-scope="scope">
           <el-button icon="el-icon-plus" v-if="scope.row.type === 'group'" type="success" size="mini" @click="addToGroup(scope.row)">Add Member</el-button>
          <el-button icon="el-icon-delete" v-if="scope.row.type === 'member'" type="danger" size="mini" @click="handleDelete(scope.row)">Del</el-button>
        </template>
      </el-table-column>
      
    </el-table>
    </el-card>

    <create-group-dialog ref="createGroupDialog" @saved="fetchData"/>

  </div>
</template>

<script>
import { getMonthlyfeeGroup, deleteMemberMonthlyfeeGroup } from '@/api/linkgroup'
import CreateGroupDialog from './group-create.vue'

export default {
  components:{
    CreateGroupDialog
  },
  data() {
    return {
      loading: false,
      allData: [],
      groupList: [],
    }
  },
  methods: {
    fetchData(){
      this.loading = true;
      getMonthlyfeeGroup().then(({result, data})=>{
        this.loading = false;
        if(result){
          this.allData = data;
          this.initGroups();
          
          // *** เพิ่มบรรทัดนี้: อัปเดตข้อมูลลูกในตารางที่กางอยู่ ***
          this.refreshLazyTree(); 
        }
        
      }) .catch(() => {
          this.loading = false
      })
    },

    // *** ฟังก์ชันใหม่: เอาข้อมูลใหม่ไปแปะทับใน Cache ของตาราง ***
    refreshLazyTree() {
      const table = this.$refs.tableemberMonthlyfeeGroup;
      if (!table) return;

      // lazyTreeNodeMap คือตัวเก็บข้อมูลลูกที่โหลดมาแล้ว (Key คือ ID ของ Group)
      const { lazyTreeNodeMap } = table.store.states;
      
      // วนลูปทุก Group ที่กำลังกางอยู่ (Expanded)
      Object.keys(lazyTreeNodeMap).forEach(groupId => {
        // กรองหาลูกๆ ของ Group นี้จาก allData ตัวใหม่ล่าสุด
        const updatedChildren = this.allData
          .filter(item => item.monthlyChargeGroup === groupId)
          .map(item => ({
             ...item,
             id: item.uid,      
             type: 'member',   
             hasChildren: false 
          }));
        
        // ใช้ $set เพื่อให้ Vue รู้ว่าค่าเปลี่ยนแล้ว (Reactivity)
        this.$set(lazyTreeNodeMap, groupId, updatedChildren);
      });
    },

    showDialog(){
      this.$refs['createGroupDialog'].show()
    },
    addToGroup(item){
      this.$refs['createGroupDialog'].show(item.name)
    },
    initGroups(){
      const uniqueGroups = [...new Set(this.allData.map(item => item.monthlyChargeGroup))];
      this.groupList = uniqueGroups.map(groupName => {
        const hasDebt = this.allData
          .filter(item => item.monthlyChargeGroup === groupName)
          .some(item => item.totalDebt && item.totalDebt.trim() !== '' && item.totalDebt !== '-');

        return {
          id: groupName,       
          name: groupName,     
          type: 'group',       
          hasChildren: true,    
          memberCode: '-',     
          enduserId: '-',
          hasDebt
        }
      });
    },
    loadMembers(row, treeNode, resolve) {
      setTimeout(() => {
        const members = this.allData
          .filter(item => item.monthlyChargeGroup === row.id)
          .map(item => ({
             ...item,
             id: item.uid,      
             type: 'member',   
             hasChildren: false 
          }));

        resolve(members);
      }, 500);
    },
    handleDelete(row){
       this.$confirm('Are you sure you want to delete this Member, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          deleteMemberMonthlyfeeGroup(row.enduserId).then(({result}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Member successfully`,
                type: 'success',
                duration: 2000
              });
              
              // วิธีที่ 1: ลบเอง Manual (เร็ว ไม่โหลดใหม่)
              this.allData = this.allData.filter(item => item.uid !== row.uid);
              const parentId = row.monthlyChargeGroup;
              const { lazyTreeNodeMap } = this.$refs.tableemberMonthlyfeeGroup.store.states;
              if (lazyTreeNodeMap[parentId]) {
                lazyTreeNodeMap[parentId] = lazyTreeNodeMap[parentId].filter(child => child.id !== row.uid);
              }
              
              // วิธีที่ 2 (Option): ถ้าอยากชัวร์ก็เรียก fetchData() ก็ได้ เพราะเราแก้ Logic แล้ว
              // this.fetchData(); 
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    }
  },
  mounted() {
    this.fetchData()
  },
}
</script>